import { render, staticRenderFns } from "./WsMenu.vue?vue&type=template&id=50186490&"
import script from "./WsMenu.vue?vue&type=script&lang=js&"
export * from "./WsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports